import React, { useState } from "react";
import "./Section5.css";

const imagesData_hdt = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=900&q=80",
    alt: "Dog in kitchen",
    tall: false,
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1504593811423-6dd665756598?auto=format&fit=crop&w=900&q=80",
    alt: "Woman with coffee",
    tall: true,
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=900&q=80",
    alt: "Legs and sneakers",
    tall: false,
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=900&q=80",
    alt: "Candles and decor",
    tall: false,
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=80",
    alt: "Person in water",
    tall: true,
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80",
    alt: "Woman in car",
    tall: false,
  },
  {
    id: 7,
    src: "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=80",
    alt: "Modern building",
    tall: false,
  },
  {
    id: 8,
    src: "https://images.unsplash.com/photo-1500375592092-40eb2168fd21?auto=format&fit=crop&w=900&q=80",
    alt: "Ship",
    tall: true,
  },
  {
    id: 9,
    src: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=900&q=80",
    alt: "Black and white",
    tall: false,
  },
];

const Section5 = () => {
  const [activeIndex_hdt, setActiveIndex_hdt] = useState(null);

  const openLightbox_hdt = (index) => {
    setActiveIndex_hdt(index);
  };

  const closeLightbox_hdt = () => {
    setActiveIndex_hdt(null);
  };

  const showPrev_hdt = (e) => {
    e.stopPropagation();
    setActiveIndex_hdt((prev) =>
      prev === 0 ? imagesData_hdt.length - 1 : prev - 1
    );
  };

  const showNext_hdt = (e) => {
    e.stopPropagation();
    setActiveIndex_hdt((prev) =>
      prev === imagesData_hdt.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="section5-hdt">
      <div className="section5-container-hdt">
        <div className="section5-grid-hdt">
          {imagesData_hdt.map((item_hdt, index_hdt) => (
            <div
              key={item_hdt.id}
              className={`section5-card-hdt ${
                item_hdt.tall ? "section5-card-tall-hdt" : ""
              } ${index_hdt === 1 ? "section5-card-big-hdt" : ""}`}
              onClick={() => openLightbox_hdt(index_hdt)}
            >
              <img src={item_hdt.src} alt={item_hdt.alt} />
              <div className="section5-overlay-hdt">
                <span className="section5-zoom-icon-hdt">+</span>
              </div>
            </div>
          ))}
        </div>

        {activeIndex_hdt !== null && (
          <div className="section5-lightbox-hdt" onClick={closeLightbox_hdt}>
            <button
              type="button"
              className="section5-lightbox-close-hdt"
              onClick={closeLightbox_hdt}
              aria-label="Close"
            >
              ×
            </button>

            <button
              type="button"
              className="section5-lightbox-nav-hdt section5-lightbox-prev-hdt"
              onClick={showPrev_hdt}
              aria-label="Previous image"
            >
              ←
            </button>

            <div
              className="section5-lightbox-content-hdt"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={imagesData_hdt[activeIndex_hdt].src}
                alt={imagesData_hdt[activeIndex_hdt].alt}
                className="section5-lightbox-img-hdt"
              />
            </div>

            <button
              type="button"
              className="section5-lightbox-nav-hdt section5-lightbox-next-hdt"
              onClick={showNext_hdt}
              aria-label="Next image"
            >
              →
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Section5;